import { createTheme } from '@mui/material/styles';

const lightTheme = createTheme({
  palette: {
    primary: {
      main: '#1e9aa7',
    },
    secondary: {
      main: '#f50057',
    },
    background: {
      default: '#f9f9f9',
    },
  },
  shape: {
    borderRadius: 10,
  },
});

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#1e9aa7',
    },
    secondary: {
      main: '#f50057',
    },
  },
  shape: {
    borderRadius: 10,
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          // backgroundColor: '#3f51b5',
        },
      },
    },
  },
});

export { lightTheme, darkTheme };
